module.exports = __webpack_public_path__ + "static/mybus-sm-db94c207b4e10016895c1352af361ed9.jpg";